{
  "languages": [
    { "name": "Afrikaans", "code": "za" },
    { "name": "Albanian", "code": "al" },
    { "name": "Amharic", "code": "et" },
    { "name": "Arabic", "code": "sa" },
    { "name": "Armenian", "code": "am" },
    { "name": "Azerbaijani", "code": "az" },
    { "name": "Basque", "code": "es" },
    { "name": "Bengali", "code": "bd" },
    { "name": "Bosnian", "code": "ba" },
    { "name": "Bulgarian", "code": "bg" },
    { "name": "Catalan", "code": "es" },
    { "name": "Cebuano", "code": "ph" },
    { "name": "Chichewa", "code": "mw" },
    { "name": "Chinese (Simplified)", "code": "cn" },
    { "name": "Chinese (Traditional)", "code": "tw" },
    { "name": "Corsican", "code": "fr" },
    { "name": "Croatian", "code": "hr" },
    { "name": "Czech", "code": "cz" },
    { "name": "Danish", "code": "dk" },
    { "name": "Dutch", "code": "nl" },
    { "name": "English", "code": "gb" },
    { "name": "Esperanto", "code": "eo" },
    { "name": "Estonian", "code": "ee" },
    { "name": "Filipino", "code": "ph" },
    { "name": "Finnish", "code": "fi" },
    { "name": "French", "code": "fr" },
    { "name": "Frisian", "code": "nl" },
    { "name": "Galician", "code": "es" },
    { "name": "Georgian", "code": "ge" },
    { "name": "German", "code": "de" },
    { "name": "Greek", "code": "gr" },
    { "name": "Gujarati", "code": "in" },
    { "name": "Haitian Creole", "code": "ht" },
    { "name": "Hausa", "code": "ng" },
    { "name": "Hawaiian", "code": "us" },
    { "name": "Hebrew", "code": "il" },
    { "name": "Hindi", "code": "in" },
    { "name": "Hmong", "code": "cn" },
    { "name": "Hungarian", "code": "hu" },
    { "name": "Icelandic", "code": "is" },
    { "name": "Igbo", "code": "ng" },
    { "name": "Indonesian", "code": "id" },
    { "name": "Irish", "code": "ie" },
    { "name": "Italian", "code": "it" },
    { "name": "Japanese", "code": "jp" },
    { "name": "Javanese", "code": "id" },
    { "name": "Kannada", "code": "in" },
    { "name": "Kazakh", "code": "kz" },
    { "name": "Khmer", "code": "kh" },
    { "name": "Kinyarwanda", "code": "rw" },
    { "name": "Korean", "code": "kr" },
    { "name": "Kurdish", "code": "iq" },
    { "name": "Kyrgyz", "code": "kg" },
    { "name": "Lao", "code": "la" },
    { "name": "Latin", "code": "va" },
    { "name": "Latvian", "code": "lv" },
    { "name": "Lithuanian", "code": "lt" },
    { "name": "Luxembourgish", "code": "lu" },
    { "name": "Macedonian", "code": "mk" },
    { "name": "Malagasy", "code": "mg" },
    { "name": "Malay", "code": "my" },
    { "name": "Malayalam", "code": "in" },
    { "name": "Maltese", "code": "mt" },
    { "name": "Maori", "code": "nz" },
    { "name": "Marathi", "code": "in" },
    { "name": "Mongolian", "code": "mn" },
    { "name": "Myanmar (Burmese)", "code": "mm" },
    { "name": "Nepali", "code": "np" },
    { "name": "Norwegian", "code": "no" },
    { "name": "Odia", "code": "in" },
    { "name": "Pashto", "code": "af" },
    { "name": "Persian", "code": "ir" },
    { "name": "Polish", "code": "pl" },
    { "name": "Portuguese", "code": "pt" },
    { "name": "Punjabi", "code": "pk" },
    { "name": "Romanian", "code": "ro" },
    { "name": "Russian", "code": "ru" },
    { "name": "Samoan", "code": "ws" },
    { "name": "Scots Gaelic", "code": "gb" },
    { "name": "Serbian", "code": "rs" },
    { "name": "Sesotho", "code": "za" },
    { "name": "Shona", "code": "zw" },
    { "name": "Sindhi", "code": "pk" },
    { "name": "Sinhala", "code": "lk" },
    { "name": "Slovak", "code": "sk" },
    { "name": "Slovenian", "code": "si" },
    { "name": "Somali", "code": "so" },
    { "name": "Spanish", "code": "es" },
    { "name": "Sundanese", "code": "id" },
    { "name": "Swahili", "code": "tz" },
    { "name": "Swedish", "code": "se" },
    { "name": "Tajik", "code": "tj" },
    { "name": "Tamil", "code": "in" },
    { "name": "Tatar", "code": "ru" },
    { "name": "Telugu", "code": "in" },
    { "name": "Thai", "code": "th" },
    { "name": "Turkish", "code": "tr" },
    { "name": "Turkmen", "code": "tm" },
    { "name": "Ukrainian", "code": "ua" },
    { "name": "Urdu", "code": "pk" },
    { "name": "Uyghur", "code": "cn" },
    { "name": "Uzbek", "code": "uz" },
    { "name": "Vietnamese", "code": "vn" },
    { "name": "Welsh", "code": "gb" },
    { "name": "Xhosa", "code": "za" },
    { "name": "Yiddish", "code": "de" },
    { "name": "Yoruba", "code": "ng" },
    { "name": "Zulu", "code": "za" }
  ]
}
